/*
  BHC DEV PDP A (Oct 28 2026): ported from WORK assets/bhc-pdp-availability.js; only change: option groups are all
  swatch groups of the main form (not only .bhc-pdp-opt), indexed by data-option-index. Loaded only for the two scoped
  products and inert when the Coming Soon list is empty.
  R9A I8b: Coming Soon on the PDP. Testament's theme.js performs the variant change (image, URL ?variant=, price,
  Add to Cart hidden / Notify Me shown for an unavailable variant). After each change this file applies the Coming
  Soon presentation for the selected variant when it is in the snippet's Coming Soon list (coming_soon and not
  sellable; the inventory guard is applied server-side):
  - shows the "Coming soon" status line and the helper line (hidden otherwise);
  - current price only: no compare-at strike, no "% off", no sale or "Sold out" price badge;
  - planned choices that lead to a Coming Soon variant stay in their normal state (no .soldout, no ", sold out").
  Runs before bhc-pdp-options.js announces, so the status is included in the announcement.
*/
(function () {
  if (window.__bhcPdpAvailability) return;
  window.__bhcPdpAvailability = true;

  function data() {
    const el = document.querySelector('[data-bhc-pdp-states]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function selectedId() {
    const input = document.querySelector('.product__section--buttons .formVariantId') || document.querySelector('input.formVariantId');
    const fromUrl = new URL(window.location.href).searchParams.get('variant');
    return String((input && input.value) || fromUrl || '');
  }

  function apply() {
    const d = data();
    if (!d) return;
    const cs = new Set((d.comingSoon || []).map(String));
    const isCs = cs.has(selectedId());

    document.querySelectorAll('[data-bhc-pdp-status], [data-bhc-pdp-helper]').forEach((el) => { el.hidden = !isCs; });

    const price = document.querySelector('.product__section--header [data-price]');
    if (price) {
      price.classList.toggle('bhc-price--cs', isCs);
      if (isCs) {
        const current = price.querySelector(price.classList.contains('price--on-sale') ? '.price__sale [data-sale-price]' : '.price__regular [data-regular-price]');
        const text = current ? current.textContent : '';
        price.classList.remove('price--on-sale', 'price--sold-out');
        const regular = price.querySelector('.price__regular [data-regular-price]');
        if (regular && text) regular.textContent = text;
      }
    }

    // Choices that resolve (with the other current choices) to a Coming Soon variant keep their normal state.
    // DEV PDP A: every swatch group of the main product form (design tiles, grouped colours and plain sizes), indexed by
    // data-option-index so the option order is exact.
    const groups = Array.from(document.querySelectorAll('.product__variants-swatches .js-variant-selector[data-option-index]'));
    const chosen = [];
    groups.forEach((g) => { const r = g.querySelector('.swatches__form--input:checked'); chosen[Number(g.dataset.optionIndex) - 1] = r ? r.value : null; });
    groups.forEach((group) => {
      const gi = Number(group.dataset.optionIndex) - 1;
      group.querySelectorAll('.swatches__form--input').forEach((radio) => {
        const opts = chosen.slice();
        opts[gi] = radio.value;
        const id = Object.keys(d.variants || {}).find((k) => d.variants[k].every((o, i) => opts[i] === undefined || opts[i] === null || o === opts[i]));
        const item = radio.closest('.swatch-element');
        if (!item) return;
        if (id && cs.has(String(id))) {
          item.classList.remove('soldout');
          item.dataset.bhcCs = '';
        } else {
          delete item.dataset.bhcCs;
        }
      });
    });
  }

  document.addEventListener('change', (event) => {
    if (!event.target.closest || !event.target.closest('.js-variant-selector')) return;
    window.setTimeout(apply, 100);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  window.bhcPdpAvailabilityApply = apply;
})();
